module.exports = __webpack_public_path__ + "static/media/19_4.839fa0f0.png";